import { createFileRoute } from "@tanstack/react-router"
import { CastSection } from "@/components/CastSection"
import { CompanySection } from "@/components/CompanySection"
import { CreatorSection } from "@/components/CreatorSection"
import { Hero } from "@/components/Hero"
import { MutuTransmission } from "@/components/MutuTransmission"
import { OutroSection } from "@/components/OutroSection"
import { PortalIntro } from "@/components/PortalIntro"
import { RobotScene } from "@/components/RobotScene"
import { StarField } from "@/components/ui/star-field"

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "EKLO | Welcome to EKLO-Verse" },
      {
        name: "description",
        content:
          "Enter EKLO-Verse — a sci-fi mythology of Kalyug's final hour. Meet the cast, the company, and the creator behind the saga.",
      },
      { property: "og:title", content: "EKLO | Welcome to EKLO-Verse" },
      {
        property: "og:description",
        content:
          "Enter EKLO-Verse — a sci-fi mythology of Kalyug's final hour.",
      },
      { property: "og:url", content: "https://eklo-seven.vercel.app" },
    ],
    links: [
      { rel: "canonical", href: "https://eklo-seven.vercel.app" },
      {
        rel: "preload",
        href: "/robot.glb",
        as: "fetch",
        type: "model/gltf-binary",
        crossOrigin: "anonymous",
        media: "(min-width: 768px)",
      },
    ],
  }),
  component: App,
})

function App() {
  return (
    <main className="relative text-white">
      <PortalIntro />
      <StarField />
      <RobotScene />

      <section id="intro">
        <Hero />
      </section>

      <MutuTransmission />

      <CastSection />
      <CompanySection />
      <CreatorSection />
      <OutroSection />
    </main>
  )
}
